/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
export const purple = {
    50: '#F4E9FE',
    100: '#E4C5FB',
    200: '#D8ACFA',
    300: '#C789F8',
    400: '#BA6DF6',
    500: '#B35FF5',
    600: '#AB45FB',
    700: '#983AE2',
    800: '#8630CA',
    900: '#7531AC',
    1000: '#482662',
};
